import { combineReducers } from 'redux-immutable';
import { resourcesReducer } from 'iguazu-rest';
import { Map } from 'immutable';

export const UPDATE_LOADER = 'modules/axp-peer-payments-partner-root/UPDATE_LOADER';
export const UPDATE_AUTH = 'modules/axp-peer-payments-partner-root/UPDATE_AUTH';
export const UPDATE_STATUS = 'modules/axp-peer-payments-partner-root/UPDATESTATUS';
export const UPDATE_ACCOUNTS = 'modules/axp-peer-payments-partner-root/UPDATE_ACCOUNTS';
export const UPDATE_SELECTED_ACCOUNT = 'modules/axp-peer-payments-partner-root/UPDATE_SELECTED_ACCOUNT';
export const UPDATE_CORRELATION_ID = 'modules/axp-peer-payments-partner-root/UPDATE_CORRELATION_ID';
export const UPDATE_ACCOUNT_GUID = 'modules/axp-peer-payments-partner-root/UPDATE_ACCOUNT_GUID';
export const UPDATE_PROFILE = 'modules/axp-peer-payments-partner-root/UPDATE_PROFILE';
export const UPDATE_REDIRECT_URI = 'modules/axp-peer-payments-partner-root/UPDATE_REDIRECT_URI';
export const UPDATE_STEPUP_DATA = 'modules/axp-peer-payments-partner-root/UPDATE_STEPUP_DATA';
export const UPDATE_PARTNER_ID = 'modules/axp-peer-payments-partner-root/UPDATE_PARTNER_ID';
export const UPDATE_LINKING_ERROR = 'modules/axp-peer-payments-partner-root/UPDATE_LINKING_ERROR';
export const UPDATE_ERROR_API = 'modules/axp-peer-payments-partner-root/UPDATE_ERROR_API';
export const UPDATE_ENROLL_ERROR = 'modules/axp-peer-payments-partner-root/UPDATE_ENROLL_ERROR';
export const UPDATE_EMAIL = 'modules/axp-peer-payments-partner-root/UPDATE_EMAIL';

/* eslint complexity: ["error", 20] -- unable to meet complexity level */

const initialState = new Map({
  p2p: {
    loader: true,
    correlationId: '',
    accountGuid: '',
    authCode: null,
    messageStatus: null,
    accounts: [],
    selectedAccount: {},
    profile: null,
    enrollError: false,
    linkingError: false,
    redirectUri: '',
    stepUpData: {},
    partnerID: 'VENMO',
    errorInApi: null,
    email: '',
  },
});

export function rootReducer(state = initialState, { type, payload } = { }) {
  switch (type) {
    case UPDATE_LOADER:
      return state.set('p2p', { ...state.get('p2p'), loader: payload });
    case UPDATE_CORRELATION_ID:
      return state.set('p2p', { ...state.get('p2p'), correlationId: payload });
    case UPDATE_ACCOUNT_GUID:
      return state.set('p2p', { ...state.get('p2p'), accountGuid: payload });
    case UPDATE_AUTH:
      return state.set('p2p', { ...state.get('p2p'), authCode: payload });
    case UPDATE_STATUS:
      return state.set('p2p', { ...state.get('p2p'), messageStatus: payload });
    case UPDATE_ACCOUNTS:
      return state.set('p2p', { ...state.get('p2p'), accounts: payload });
    case UPDATE_SELECTED_ACCOUNT:
      return state.set('p2p', { ...state.get('p2p'), selectedAccount: payload });
    case UPDATE_PROFILE:
      return state.set('p2p', { ...state.get('p2p'), profile: payload });
    case UPDATE_REDIRECT_URI:
      return state.set('p2p', { ...state.get('p2p'), redirectUri: payload });
    case UPDATE_STEPUP_DATA:
      return state.set('p2p', { ...state.get('p2p'), stepUpData: payload });
    case UPDATE_PARTNER_ID:
      return state.set('p2p', { ...state.get('p2p'), partnerID: payload });
    case UPDATE_LINKING_ERROR:
      return state.set('p2p', { ...state.get('p2p'), linkingError: payload });
    case UPDATE_ERROR_API:
      return state.set('p2p', { ...state.get('p2p'), errorInApi: payload });
    case UPDATE_ENROLL_ERROR:
      return state.set('p2p', { ...state.get('p2p'), enrollError: payload });
    case UPDATE_EMAIL:
      return state.set('p2p', { ...state.get('p2p'), email: payload });
    default:
      return state;
  }
}

export const reducer = combineReducers({
  rootReducer,
  resources: resourcesReducer,
});

export default reducer;
